import { Link } from "react-router-dom";
import { caseCategories } from "@/mocks/cases";
import { siteInfo } from "@/mocks/site";

const SiteFooter = () => (
  <footer className="bg-primary-900 text-primary-50">
    <div className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
              <i className="ri-folder-shield-2-line" />
            </span>
            <span className="font-heading font-bold text-lg">{siteInfo.name}</span>
          </div>
          <p className="text-sm leading-relaxed text-primary-200">
            {siteInfo.slogan}
          </p>
          <p className="mt-4 text-xs leading-relaxed text-primary-300">
            站内人物均为化名，内容为网络公开讨论的娱乐整理与评论。
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-base mb-4">
            <Link to="/cases" className="hover:text-primary-200 transition-colors">
              塌房合集
            </Link>
          </h4>
          <ul className="space-y-2.5 text-sm text-primary-200">
            {caseCategories.map((cat) => (
              <li key={cat.key}>
                <Link
                  to={`/cases?category=${encodeURIComponent(cat.key)}`}
                  className="hover:text-primary-50 transition-colors"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-base mb-4">站点导航</h4>
          <ul className="space-y-2.5 text-sm text-primary-200">
            <li>
              <Link to="/" className="hover:text-primary-50 transition-colors">
                首页
              </Link>
            </li>
            <li>
              <Link to="/cases" className="hover:text-primary-50 transition-colors">
                全部案例
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-primary-50 transition-colors">
                关于与爆料
              </Link>
            </li>
            <li>
              <Link to="/about#submit" className="hover:text-primary-50 transition-colors">
                投稿线索
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-base mb-4">联系我们</h4>
          <ul className="space-y-2.5 text-sm text-primary-200">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5" />
              <span className="break-all">{siteInfo.email}</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-time-line mt-0.5" />
              <span>线索核对：工作日 10:00 - 18:00</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-error-warning-line mt-0.5" />
              <span>内容异议请在邮件中附上依据，我们会尽快处理</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
        <p>© 2026 {siteInfo.name} · 档案整理仅供娱乐参考</p>
        <p>所有人物均为化名，请勿对号入座</p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;